import { createContext } from 'react';

export const readonlyContext = createContext(false);
